import script from "./UserManage.vue?vue&type=script&setup=true&lang=js"
export * from "./UserManage.vue?vue&type=script&setup=true&lang=js"

import "./UserManage.vue?vue&type=style&index=0&id=77f81c70&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77f81c70"]])

export default __exports__